<script setup lang="ts">
import { UiText } from "@shopexperts/shared";

defineProps<{
    label: string;
    value?: string | null;
}>();
</script>

<template>
    <div class="min-w-0">
        <UiText
            as="p"
            variant="caption-normal"
            class="text-se-gray-500 uppercase tracking-wider text-xs"
            :text="label"
        />
        <slot>
            <UiText as="p" variant="p" class="font-medium text-se-dark break-words" :text="value || '—'" />
        </slot>
    </div>
</template>
